import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import { Autocomplete, TextField, styled } from "@mui/material";
import MDBox from "components/MDBox";

export const EditableDatePicker_ = ({ getValue, row, column, table }) => {
  const [selected, setSelected] = useState(null);
  return (
    <DatePicker
      showIcon
      selected={row.original[column.id] === null ? null : dayjs(row.original[column.id]).toDate()}
      onChange={(date) => {
        let value;
        if (date === null) {
          value = date;
        } else {
          value = dayjs(date).format("YYYY-MM-DD HH:mm");
        }
        //setSelected(date);
        table.options.meta?.updateData(row.index, column.id, value);
      }}
      timeInputLabel="Time:"
      showTimeInput
      dateFormat="dd/MM/yyyy h:mm aa"
    />
  );
};

const StyledAutocomplete = styled(Autocomplete)({
  "&.MuiAutocomplete-root .MuiOutlinedInput-notchedOutline": { border: "0px solid red" },
  "&.MuiAutocomplete-root": { width: "100% !important" },
});

export const EditableSelectCustomOnChange = ({ getValue, onChange, options, ...props }) => {
  return (
    <StyledAutocomplete
      isOptionEqualToValue={(option, value) => {
        if (option.value) {
          return option.label === value || option.value === value;
        } else {
          return option === value;
        }
      }}
      value={getValue()}
      options={options}
      onChange={onChange}
      disableClearable={false}
      {...props}
      renderInput={(params) => <TextField {...params} label="" />}
    />
  );
};

export const EditableSelect = ({ getValue, row, column, table, options }) => {
  return (
    <MDBox sx={{ width: "150px" }}>
      <StyledAutocomplete
        isOptionEqualToValue={(option, value) => {
          if (option.value) {
            return option.label === value || option.value === value;
          } else {
            return option === value;
          }
        }}
        value={getValue()}
        options={options}
        onChange={(e, value) => table.options.meta?.updateData(row.index, column.id, value)}
        disableClearable={true}
        renderInput={(params) => <TextField variant="standard" {...params} label="" />}
      />
    </MDBox>
  );
};

export const EditableText = ({ getValue, row, column, table }) => {
  const { id } = column;

  const handleChange = (e) => {
    const newValue = e.target.value;
    table.options.meta?.updateData(row.index, id, newValue);
  };

  return (
    <TextField
      label=""
      name={id}
      sx={{ "&.MuiTextField-root .MuiOutlinedInput-notchedOutline": { border: "0px solid red" } }}
      variant="standard"
      placeholder="Type a reason"
      value={getValue() ?? ""}
      inputProps={{ maxLength: 100 }}
      onChange={handleChange}
    />
  );
};

export const EditableNumber = ({ getValue, row, column, table }) => {
  const { id } = column;

  const handleChange = (e) => {
    const newValue = e.target.value;
    console.log("fromhandlechangeineditabletext",newValue);
    table.options.meta?.updateData(row.index, id, newValue);
  };

  return (
    <TextField
      label=""
      name={id}
      sx={{ "&.MuiTextField-root .MuiOutlinedInput-notchedOutline": { border: "0px solid red" } }}
      variant="standard"
      placeholder="Type a reason"
      value={getValue() ?? 0}
      inputProps={{ maxLength: 100 }}
      onChange={handleChange}
      type='number'
    />
  );
};
